var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "manage-campaign col-md-12" }, [
    _c("h2", [_vm._v("Manage Campaign")]),
    _c(
      "table",
      [
        _vm._m(0),
        _vm._l(_vm.campaigns, function(camp) {
          return _vm.campaigns.length
            ? _c("tr", { key: camp.id }, [
                _c("td", [
                  _c("h5", [_vm._v(_vm._s(camp.campaign_name))]),
                  _c("ul", [
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/sadmin/" + camp.id + "/quick-review"
                            }
                          },
                          [_vm._v("Quick Review")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/sadmin/" + camp.id + "/advanced-review"
                            }
                          },
                          [_vm._v("Advanced Review")]
                        )
                      ],
                      1
                    ),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            "data-toggle": "modal",
                            "data-target": "#exampleModal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.setCampValue(camp.id)
                            }
                          }
                        },
                        [_vm._v("Add notes")]
                      )
                    ])
                  ])
                ]),
                _vm._m(1, true),
                _c("td", [_vm._v(_vm._s(camp.geo_location_type))]),
                _c("td", [_vm._v(_vm._s(camp.package_name))]),
                _c("td", [_vm._v(_vm._s(camp.campaign_budget))])
              ])
            : _vm._e()
        }),
        _vm.campaigns.length == 0
          ? _c("tr", [
              _c(
                "td",
                {
                  staticStyle: { "text-align": "center", "font-size": "18px" },
                  attrs: { colspan: "5" }
                },
                [_vm._v("No Pending Campaign For Approval")]
              )
            ])
          : _vm._e()
      ],
      2
    ),
    _c(
      "div",
      {
        staticClass: "modal fade note_popup",
        attrs: {
          id: "exampleModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(2),
              _c("div", { staticClass: "modal-body" }, [
                _c("h5", [_vm._v("Leave a note for brand")]),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.note,
                      expression: "note"
                    }
                  ],
                  attrs: { placeholder: "Type your notes here", name: "note" },
                  domProps: { value: _vm.note },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.note = $event.target.value
                    }
                  }
                })
              ]),
              _c("div", { staticClass: "center" }, [
                _c(
                  "button",
                  {
                    ref: "exitModel",
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [_vm._v("Exit")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.sendCampaignNote()
                      }
                    }
                  },
                  [_vm._v("Send")]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticStyle: { "border-bottom": "1px solid #000" } }, [
      _c("th", [_vm._v("Name")]),
      _c("th", [_vm._v("Status")]),
      _c("th", [_vm._v("Geo-Targeting Type")]),
      _c("th", [_vm._v("Benefit Package")]),
      _c("th", [_vm._v("Campaign Budget")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "button",
        { staticClass: "awaiting_approval", staticStyle: { border: "0px" } },
        [_vm._v("Awaiting Approval")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", [_vm._v("Add a Note")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }